<template>
  <LayoutCard class="nps-card" @click="emits('open', item.interventionId)">
    <div class="nps-row">
      <div>
        <CommonChip transparent color="dark">{{ getDate() }}</CommonChip>
      </div>
      <p class="backer">{{ item.backer || '—' }}</p>
      <p class="customer">{{ item.customer || '—' }}</p>
      <p class="score">{{ formatScore(item.score) }}</p>
      <CommonIconButton icon="ArrowRight" />
    </div>
  </LayoutCard>
</template>

<script setup lang="ts">
import CommonChip from '@/components/common/CommonChip.vue'
import CommonIconButton from '@/components/common/CommonIconButton.vue'
import LayoutCard from '@/components/layout/LayoutCard.vue'
import { formatScore } from '@/services/service_nps'
import type { NpsResultItem } from 'types/api/nps'

const props = defineProps<{
  item: NpsResultItem
}>()

const emits = defineEmits<{
  (e: 'open', interventionId: number): void
}>()

function getDate() {
  return new Date(props.item.date).toLocaleDateString('fr-FR')
}
</script>

<style scoped lang="scss">
.nps-card {
  transition: 600ms cubic-bezier(0.19, 1, 0.22, 1);
  cursor: pointer;
  padding: 10px 20px;
}

.nps-card:hover {
  transition: 600ms cubic-bezier(0.19, 1, 0.22, 1);
  border-color: rgba(var(--vcrgb-dark), 0.5);
}

.nps-row {
  display: grid;
  grid-template-columns: var(--nps-columns, 130px 2fr 2fr 1fr 40px);
  align-items: center;
  gap: 10px;
}

.backer,
.score {
  color: var(--vc-dark);
  font-weight: 600;
}

.customer {
  color: rgba(var(--vcrgb-dark), 0.75);
}
</style>
